<template>
    <div class="card maxCaptl acc">
      <div class="card-header bg-transparent">
        <div class="row align-items-center">
            <div class="col black">
              <h3><i class="fas fa-cog"></i> Choose Account</h3>
            </div>
        </div>
      </div>
      <div class="input-group">
         <label 
            for="inputEmail3" class="col-form-label">
            TMC
          </label>
        <select class="form-control" v-model="tmcAccountId" >
          <option value="">Choose A/C No</option>
          <option
                v-for="tmc in tmcAccountList"
                :key="tmc.id"
                v-bind:value="tmc.id"
            >{{tmc.account}}</option>
        </select>
        <div class="input-group-append">
          <button type="button" @click="setAccount('TMC')">
            <i v-if="!tmcLoading" class="fas fa-check"  v-bind:class="tmcAccountId == '' ? 'fa-disabled' : ''"></i>
            <i v-if="tmcLoading" class="fa fa-spinner fa-spin"></i>
          </button>
        </div>
      </div>
      <div class="input-group">
        <label 
            for="inputEmail3" 
            class="col-form-label">
            BondPoint
          </label>
        <select class="form-control" v-model="bpAccountId" >
          <option value="">Choose A/C No</option>
          <option
                v-for="bp in bpAccountList"
                :key="bp.id"
                v-bind:value="bp.id"

            >{{bp.account}}</option>
        </select>
        <div class="input-group-append">
          <button type="button" @click="setAccount('BONDPOINT')">
            <i v-if="!bpLoading" class="fas fa-check"  v-bind:class="bpAccountId == '' ? 'fa-disabled' : ''"></i>
            <i v-if="bpLoading" class="fa fa-spinner fa-spin"></i>
          </button>
        </div>
      </div>
      <div class="input-group">
        <label 
            for="inputEmail3" 
            class="col-form-label">
            TradeWeb
          </label>
        <select class="form-control mb-2" v-model="twAccountId" >
          <option value="">Choose A/C No</option>
          <option
                v-for="tw in twAccountList"
                :key="tw.id"
                v-bind:value="tw.id"

            >{{tw.account}}</option>
        </select>
        <div class="input-group-append">
          <button type="button" @click="setAccount('TRADEWEB')">
            <i v-if="!twLoading" class="fas fa-check"  v-bind:class="twAccountId == '' ? 'fa-disabled' : ''"></i>
            <i v-if="twLoading" class="fa fa-spinner fa-spin"></i>
          </button>
        </div>
      </div>
    </div>
</template>
<script>
import authService from "@/authService";
//import axios from "axios";
import config from "@/config";
export default {
  name: "setAccount",
  props: ["bidSettings"],
  watch: {
    $props: {
      handler: function() {
        this.tmcAccountId = this.bidSettings.tmcAccountId+"" || "";
        this.bpAccountId = this.bidSettings.bpAccountId || "";
        this.twAccountId = this.bidSettings.twAccountId || "";
      },
      deep: true
    }
  },
  data() {
    return {
      tmcAccountId : "",
      bpAccountId : "",
      twAccountId : "",
      tmcAccountList : [],
      bpAccountList : [],
      twAccountList : [],
      tmcLoading : false,
      bpLoading : false,
      twLoading : false,
    };
  },
  methods: {
    setAccount(ecn){
      if(ecn == 'TMC'){
       this.tmcLoading = true
      }
      if(ecn == 'BONDPOINT'){
       this.bpLoading = true
      }
      if(ecn == 'TRADEWEB'){
       this.twLoading = true
      }
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .put(
          config.baseUrlBidSide + "/organization/bid-settings",
          {
            bpAccountId : this.bpAccountId,
            tmcAccountId : this.tmcAccountId,
            twAccountId : this.twAccountId,
            orgType : "BID"
          },
          auth
        )
        .then(() => {
          this.tmcLoading = false;
          this.bpLoading = false;
          this.twLoading = false;
          this.$alert(this.appMessages.accountSetSuccess);         
        })
        .catch(e => {
          console.log(e);
          this.tmcLoading = false;
          this.bpLoading = false;
          this.twLoading = false;

        });
    },
    getAccountList(){
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide + "/account/list?ecn=IBP,TMC,TWD",
          auth
        )
        .then(response => {
            this.bpAccountList = response.data.filter((item) => {
                return item.ecn == 'IBP' && (item.accountValue != 'SMU0000042')
            });
            this.tmcAccountList = response.data.filter((item) => {
                return item.ecn == 'TMC'
            });
            this.twAccountList = response.data.filter((item) => {
                return item.ecn == 'TWD'
            });
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  mounted() {
      this.getAccountList();
  }
};
</script>